import { render } from "./ColumnHeader.vue?vue&type=template&id=5d7d859c&scoped=true"
import script from "./ColumnHeader.vue?vue&type=script&lang=js"
export * from "./ColumnHeader.vue?vue&type=script&lang=js"

import "./ColumnHeader.vue?vue&type=style&index=0&id=5d7d859c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7d859c"]])

export default __exports__